const getVimeoThumbnail = async (vimeoId: string) => {
  try {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeoId}`);
    if (!response.ok) {
      return {};
    }
    return response.json();
  } catch {
    return {};
  }
};

export default getVimeoThumbnail;
